module.exports = __webpack_public_path__ + "img/no-message2.e326f4bd.png";